import { Pipe, PipeTransform } from '@angular/core';
const DEFAULT_AMOUNT = '0';

@Pipe({
  name: 'indianCurrency',
  standalone: true
})
export class IndianCurrencyPipe implements PipeTransform {

  defaultAmount = `₹${DEFAULT_AMOUNT}`;

  // transform(amount: number | string): string {
  //   if (!(typeof amount === 'number' || typeof amount === 'string')) {
  //     return this.defaultAmount;
  //   }
  //   if (!isValidCurrency(amount.toString())) {
  //     return this.defaultAmount;
  //   }

  //   // Round the amount to nearest integer
  //   const roundedAmount = Math.round(Number(amount));
  //   return `₹${roundedAmount.toString().replace(/(\d)(?=(\d\d)+\d$)/g, '$1,')}`;
  // }

  transform(amount: number | string): string {
    if (typeof amount !== 'number' && typeof amount !== 'string') {
      return this.defaultAmount;
    }

    if (!isValidCurrency(amount.toString())) {
      return this.defaultAmount;
    }

    const num = Number(amount);
    if (isNaN(num)) {
      return this.defaultAmount;
    }

    // Format with two decimal precision (for consistency)
    const roundedAmount = num.toFixed(2);
    const parts = roundedAmount.split('.');

    const integerPart = parts[0] ?? '0';
    const decimalPart = parts[1] ?? '00';

    // Apply Indian numbering format
    const formattedInteger = integerPart.replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');

    // Only show decimals if they’re not "00"
    const formattedAmount =
      decimalPart !== '00' ? `${formattedInteger}.${decimalPart}` : formattedInteger;

    return `₹${formattedAmount}`;
  }

}

export function isValidCurrency(str: string) {
  str = str.trim();
  if (!str) {
    return false;
  }
  str = str.replace(/^0+/, '') || '0';
  const n = Math.floor(Number(str));
  return n !== Infinity && n >= 0 && isFinite(n);
}
